import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=d6810afc&scoped=true"
import script from "./priceList.vue?vue&type=script&lang=js"
export * from "./priceList.vue?vue&type=script&lang=js"
import style0 from "./priceList.vue?vue&type=style&index=0&id=d6810afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6810afc",
  null
  
)

export default component.exports